export default __webpack_public_path__ + "static/media/0eabfd43844e93b7ea72da84218101a61581606019968.6bc33cf6.webp";